/**
 * Legacy global key (pre–per-set persistence). Unused for writes; kept for reference
 * and any one-off tooling.
 *
 * @deprecated Use {@link storageKeyOpportunityRowOrder} / namespaced helpers.
 */
export const OPPORTUNITY_ROW_ORDER_STORAGE_KEY = "nexus_opportunity_row_order"

/** localStorage key for drag order shared between table + card views for one set. */
export function storageKeyOpportunityRowOrder(tenantId: string, setId: string): string {
  return `nexus_opportunity_row_order:${tenantId}:${setId}`
}

export function readStoredOpportunityRowOrder(tenantId: string, setId: string): string[] {
  try {
    const stored = localStorage.getItem(storageKeyOpportunityRowOrder(tenantId, setId))
    if (stored) return JSON.parse(stored) as string[]
  } catch { /* corrupted or private browsing */ }
  return []
}

export function writeStoredOpportunityRowOrder(
  tenantId: string,
  setId: string,
  ids: readonly string[],
): void {
  try {
    localStorage.setItem(storageKeyOpportunityRowOrder(tenantId, setId), JSON.stringify(ids))
  } catch { /* private browsing etc. */ }
}

/** Reorder stable records by persisted id list; unknown ids append in original relative order. */
export function sortByStoredOpportunityIds<T extends { id: string }>(
  records: readonly T[],
  rowOrder: readonly string[],
): T[] {
  if (rowOrder.length === 0) return records as T[]
  const map = new Map(records.map((r) => [r.id, r]))
  const ordered: T[] = []
  for (const id of rowOrder) {
    const r = map.get(id)
    if (r) {
      ordered.push(r)
      map.delete(id)
    }
  }
  for (const r of map.values()) ordered.push(r)
  return ordered
}
